import TOAST_ICONS from '@shared/constants/toastIcons';
import { TOAST_MESSAGE_TYPES } from '@shared/constants/toastMessageTypes';
import { Slide, toast } from 'react-toastify';

const SECONDS_FOR_HIDING_SUCCESS_MESSAGE = 5000;
const SECONDS_FOR_HIDING_ERROR_MESSAGE = 4000;
const SECONDS_FOR_HIDING_INTO_MESSAGE = 10000;
const SECONDS_FOR_HIDING_WARNING_MESSAGE = 4000;

const TOAST_DEFAULT_OPTIONS = /** @type {const} */ ({
  position: 'top-center',
  autoClose: SECONDS_FOR_HIDING_SUCCESS_MESSAGE,
  hideProgressBar: false,
  closeOnClick: false,
  pauseOnHover: false,
  progress: undefined,
  theme: 'light',
  transition: Slide
});

export const getToastOptions = (type, notificationId, excludeFromNotificationCenter, isLoading) => {
  const baseOptions = {
    toastId: notificationId,
    ...TOAST_DEFAULT_OPTIONS,
    type,
    data: {
      exclude: excludeFromNotificationCenter
    },
    icon: TOAST_ICONS[type],
    isLoading
  };

  return { ...baseOptions, ...toastTypeOptionsMap[type] };
};

export const showToast = (
  type,
  message,
  notificationId = null,
  excludeFromNotificationCenter = true,
  isLoading = false
) => {
  const options = getToastOptions(type, notificationId, excludeFromNotificationCenter, isLoading);
  return toast(message, options);
};

export const showSuccessToast = message => {
  showToast(TOAST_MESSAGE_TYPES.SUCCESS, message);
};

export const showWarningToast = message => {
  showToast(TOAST_MESSAGE_TYPES.WARNING, message);
};

export const showErrorToast = message => {
  showToast(TOAST_MESSAGE_TYPES.ERROR, message);
};

export const showInfoToast = message => {
  showToast(TOAST_MESSAGE_TYPES.INFO, message);
};

const toastTypeOptionsMap = /** @type {const} */ ({
  [TOAST_MESSAGE_TYPES.SUCCESS]: { className: 'success-toast' },
  [TOAST_MESSAGE_TYPES.INFO]: { autoClose: SECONDS_FOR_HIDING_INTO_MESSAGE },
  [TOAST_MESSAGE_TYPES.ERROR]: {
    autoClose: SECONDS_FOR_HIDING_ERROR_MESSAGE,
    position: 'top-right'
  },
  [TOAST_MESSAGE_TYPES.WARNING]: {
    autoClose: SECONDS_FOR_HIDING_WARNING_MESSAGE
  }
});
